import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class Button extends React.PureComponent {
  render() {
    const { children, classes, className, color, size, ...other } = this.props;
    return (
      <ButtonBase
        focusRipple
        className={`${classes.button} ${className || ''} ${classes[color]} ${classes[size]}`}
        {...other}
      >
        <span className={`${classes.label} ${classes[`label-${size}`]}`}>{children}</span>
      </ButtonBase>
    );
  }
}

Button.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
};

Button.defaultProps = {
  color: 'grey',
  size: 'medium',
};

export default withStyles(styles)(Button);
